import type { IconData } from '@stacksjs/iconify-core'

export const arrowRightCircle1Flat: IconData = {
  "body": "<g fill=\"none\" fill-rule=\"evenodd\" clip-rule=\"evenodd\"><path fill=\"#8fbffa\" d=\"M46.5 24c0 12.426-10.074 22.5-22.5 22.5S1.5 36.426 1.5 24S11.574 1.5 24 1.5S46.5 11.574 46.5 24\"/><path fill=\"#2859c5\" d=\"M24.146 24.353a.5.5 0 0 0 0-.707l-6.498-6.498c-.97-.97-1.169-2.487-.29-3.539c.701-.838 1.537-1.673 2.392-2.275c1.008-.708 2.302-.376 3.218.447c3.274 2.942 7.602 7.329 9.779 10.211c.919 1.218.92 2.797 0 4.015c-2.177 2.883-6.505 7.27-9.779 10.211c-.916.823-2.21 1.156-3.218.447c-.855-.602-1.69-1.436-2.392-2.275c-.879-1.052-.68-2.569.29-3.538z\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default arrowRightCircle1Flat
